import TerminList from './TerminList';

export default TerminList;
